import { Component, effect, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigurationsSelectors } from 'demand-forecasting/store/configurations/configurations.selectors';
import { isForecastSeriesFetchingOrPending } from 'demand-forecasting/store/forecast-series/forecast-series.selectors';

import { ConfigurationRouterHelperService } from 'demand-forecasting/store/router-state/configuration-router-helper.service';
import { FormFieldComponent, FormInputSelectComponent } from '@libs/ui';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ArrayToSelectFieldOptionPipe } from '@core/utils/array-to-select-field-option.pipe';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

@Component({
  selector: 'pm-additional-time-series-picker',
  templateUrl: './additional-time-series-picker.component.html',
  imports: [
    TranslateModule,
    FormFieldComponent,
    FormInputSelectComponent,
    FormsModule,
    ArrayToSelectFieldOptionPipe,
    ReactiveFormsModule,
  ],
})
export class AdditionalTimeSeriesPickerComponent {
  public timepickerControl = new FormControl();

  private readonly store = inject(Store);
  protected configurationRouterHelperService = inject(
    ConfigurationRouterHelperService,
  );

  protected selectAdditionalTimeSeriesNames = this.store.selectSignal(
    ConfigurationsSelectors.selectAdditionalTimeSeriesNames,
  );

  protected selectedAdditionalTimeSeriesNames = this.store.selectSignal(
    ConfigurationsSelectors.selectAdditionalTimeSeriesNamesByUrlParam,
  );

  protected isPending = this.store.selectSignal(
    isForecastSeriesFetchingOrPending,
  );

  constructor() {
    effect(() => {
      const timeSeries = this.selectedAdditionalTimeSeriesNames();
      this.timepickerControl.setValue(timeSeries);
    });

    this.timepickerControl.valueChanges
      .pipe(
        takeUntilDestroyed(),
        filter((timeSeriesName) => Array.isArray(timeSeriesName)),
      )
      .subscribe((timeSeriesName) => {
        this.configurationRouterHelperService.updateSelectedAdditionalTimeSeries(
          timeSeriesName,
        );
      });
  }
}
